import { Injectable } from '@angular/core';
import { AttendanceChannel } from '../interfaces/attendance';
import {
  CHANNELS_WITH_AUDIO_RECORD,
  CHANNELS_WITH_FILE_UPLOAD,
  CHANNELS_WITH_REPLY,
  META_COMPANY_CHANNELS,
} from '../constants/channel.constant';

@Injectable({
  providedIn: 'root'
})
export class ChannelUtilsService {
  isMetaChannel(channel: AttendanceChannel) {
    return META_COMPANY_CHANNELS.includes(channel);
  }

  isBookingChannel(channel: AttendanceChannel) {
    return channel === AttendanceChannel.BOOKING;
  }

  isExpediaChannel(channel: AttendanceChannel) {
    return channel === AttendanceChannel.EXPEDIA;
  }

  isTiktokChannel(channel: AttendanceChannel) {
    return channel === AttendanceChannel.TIKTOK;
  }

  isTelegramChannel(channel: AttendanceChannel) {
    return channel === AttendanceChannel.TELEGRAM;
  }

  isWhatsappChannel(channel: AttendanceChannel) {
    return channel === AttendanceChannel.WHATSAPP;
  }

  isChannelWithFileUpload(channel: AttendanceChannel) {
    return CHANNELS_WITH_FILE_UPLOAD.includes(channel);
  }

  isChannelWithAudioRecord(channel: AttendanceChannel) {
    return CHANNELS_WITH_AUDIO_RECORD.includes(channel);
  }

  isChannelWithReply(channel: AttendanceChannel) {
    return CHANNELS_WITH_REPLY.includes(channel);
  }

  isInstagramChannel(channel: AttendanceChannel) {
    return channel === AttendanceChannel.INSTAGRAM;
  }
}
